export const DARK_THEME_CSS_VARIABLES = {
  '--tv-color-scrollbar-thumb': '#767D97',
};

export const LIGHT_THEME_CSS_VARIABLES = {
  '--tv-color-scrollbar-thumb': '#d0d0d0',
};
